import {instantse} from "@providers/request";

export const Roles = {
    getAll: () => {
        return instantse.get(`/v1/role`).then((response) => response)
    }
}